<template>
    <div>
        <div class="flex justify-end">
            <vs-button icon-pack="feather" icon="icon-trash-2" color="danger" type="border" class="mr-4"
                       @click="deleteFileMulti" v-if="selected.length > 0">
                {{ $t('tasks.deleteSelectedFile') }}
            </vs-button>
            <vs-button icon-pack="feather" icon="icon-plus" color="primary" @click="openPopupAddFiles">{{
                    $t('tasks.addFiles')
                }}
            </vs-button>
        </div>
        <div class="vx-card p-6 mt-4 title-item">
            <vs-table multiple stripe noDataText="Không có dữ liệu" search :data="fileDataTable"
                      v-model="selected" :pagination="fileDataTable.length > 0" max-items="20">
                <template slot="thead">
                    <vs-th>
                        STT
                    </vs-th>
                    <vs-th>
                        {{ $t('tasks.files') }}
                    </vs-th>
                    <vs-th>{{ $t('tasks.uploadedBy') }}</vs-th>
                    <vs-th>{{ $t('tasks.createdDate') }}</vs-th>
                    <vs-th>{{ $t('tasks.action') }}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr v-for="(filesItem, ind) in data" :data="filesItem" :key="ind">
                        <vs-td>
                            <div>{{ ind + 1 }}</div>
                        </vs-td>
                        <vs-td>
                            <div class="text-primary" @mousedown.stop="previewImage(filesItem)"> {{ filesItem.name }}
                            </div>
                        </vs-td>
                        <vs-td>
                            <div>{{ filesItem.createdBy }}</div>
                        </vs-td>
                        <vs-td>
                            <div> {{ filesItem.createdDateCvt }}</div>
                        </vs-td>
                        <vs-td>
                            <div class="flex gap-4">
                                <vx-tooltip class="position-icon" :text="$t('button.download')" position="top">
                                    <feather-icon icon="DownloadIcon" class="text-primary"
                                                  svgClasses="h-5 w-5 cursor-pointer"
                                                  @mousedown.stop="dowloadFile(filesItem)"/>
                                </vx-tooltip>
                                <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                                    <feather-icon icon="TrashIcon" class="text-danger"
                                                  svgClasses="h-5 w-5 cursor-pointer"
                                                  @mousedown.stop="deleteFile(filesItem.id)"/>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <vs-popup title="Tải lên file" :active.sync="popupUploadFiles" id="popup-upload-file">
                <div class="vx-row">
                    <div class="vx-col w-full flex flex-wrap mt-4">
                        <div class="flex justify-center upload">
                            <div class="file-upload" @dragover="dragover" @dragleave="dragleave"
                                 @drop="drop">
                                <input ref="file" type="file" id="imageUpload" multiple
                                       class="hidden" @change="uploadFile()">
                                <div class="">
                                    <div class="text-center">
                                        <feather-icon icon="UploadCloudIcon" svgClasses="h-10 w-10 text-primary"/>
                                    </div>
                                    <div class="text-center button-upload">
                                        <vs-button @click="$refs.file.click()">Chọn tệp</vs-button>
                                    </div>
                                    <div class="text-center mt-4">
                                        <label class="file-label text-primary">
                                            <div v-if="isDragging">Nhả để thả tập tin vào đây</div>
                                            <div v-else>Thả tập tin ở đây</div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-files">
                            <vs-table stripe :pagination="files.length > 0" maxItems="4" :data="files"
                                      noDataText="Không có dữ liệu">
                                <template slot="thead">
                                    <vs-th>
                                        STT
                                    </vs-th>
                                    <vs-th>
                                        Name
                                    </vs-th>
                                    <vs-th>
                                        Actions
                                    </vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td>
                                            {{ indextr + 1 }}
                                        </vs-td>

                                        <vs-td class="text-primary">
                                            {{ tr.name }}
                                        </vs-td>

                                        <vs-td>
                                            <div class="flex items-center">
                                                <vx-tooltip class="position-icon" :text="$t('button.delete')"
                                                            position="top">
                                                    <feather-icon icon="TrashIcon" class="action-err icon-btn"
                                                                  svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                                                  @click="confirmDeleteRecord(tr, indextr)"/>
                                                </vx-tooltip>
                                            </div>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-4 flex justify-end gap-2">
                        <vs-button @click="addFile" :disabled="files.length === 0">{{ $t('tasks.add') }}</vs-button>
                        <vs-button color="danger" type="border" @click="popupUploadFiles = false">{{
                                $t('tasks.close')
                            }}
                        </vs-button>
                    </div>
                </div>
            </vs-popup>


        </div>
    </div>
</template>
<script>
import {AgGridVue} from "ag-grid-vue";
import Multiselect from 'vue-multiselect';
import moment from "moment";
import Axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    components: {
        AgGridVue,
        Multiselect,
        Axios,
        VuePerfectScrollbar
    },
    data() {
        return {
            popupUploadFiles: false,
            projectId: 'null',
            files: [],
            fileDataTable: [],
            selected: [],
            openTrash: false,
            searchText: '',
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            isDragging: false,
        }
    },
    created() {
        this.projectId = parseInt(this.$route.query.id, 10)
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t('warningMenuOrganization.emptyEmployee'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
        }
        this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(item => {
            return {value: item.id, label: item.organizationBranchName}
        })
        this.organizationBranchOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
        this.getFileDetail()
    },

    methods: {
        openPopupAddFiles() {
            this.files = []
            this.popupUploadFiles = true
        },

        addFile() {
            let formData = new FormData(),
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };
            this.files.forEach(el => formData.append('files', el))
            this.$vs.loading()
            this.$crm.post(`/project/upload-file/${this.projectId}`, formData, config).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Tải tệp thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.files = []
                this.getFileDetail()
                this.popupUploadFiles = false
            }).catch(err => {
                this.files = []
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },

        dowloadFile(file) {
            window.open(`https://file2.inviv.vn/api/v1/file-entries/download/${file.metaData.fileEntry.hash}?workspaceId=0`, '_blank')
        },

        previewImage(file) {
            if (file.metaData.fileEntry.type === 'pdf') file['src'] = 'https://file2.inviv.vn/' + file.metaData.fileEntry.url + '?workspaceId=' + file.metaData.fileEntry.workspace_id + '&thumbnail=' + file.metaData.fileEntry.thumbnail + '#toolbar=0'
            if (file.metaData.fileEntry.type === 'spreadsheet' || file.metaData.fileEntry.type === 'powerPoint' ||  file.metaData.fileEntry.type === 'word') file['src'] = 'https://view.officeapps.live.com/op/embed.aspx?src='+'https://file2.inviv.vn/' + file.metaData.fileEntry.url + '?workspaceId=' + file.metaData.fileEntry.workspace_id + '&thumbnail=' + file.metaData.fileEntry.thumbnail
            window.open(file.src ? file.src : file.url, '_blank')
        },

        deleteFile(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa tệp này không ?`,
                accept: () => this.acceptDeleteFileOne(id),
                acceptText: "Xóa",
                cancelText: "Huỷ"
            })
        },

        acceptDeleteFileOne(id) {
            this.$vs.loading();
            this.$crm.delete(`/project/delete-file/${this.projectId}?fileIds=${[id]}`).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Xóa thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.getFileDetail();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });

            });
        },

        deleteFileMulti() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa tệp này không ?`,
                accept: this.acceptDeleteFile,
                acceptText: "Xóa",
                cancelText: "Huỷ"
            })
        },

        acceptDeleteFile() {
            let fileIds = this.selected.map(el => el.id)
            this.$vs.loading();
            this.$crm.delete(`/project/delete-file/${this.projectId}?fileIds=${fileIds}`).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Xóa thành công`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
                this.selected = []
                this.getFileDetail();
            }).catch(err => {
                this.selected = []
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            });
        },

        getFileDetail() {
            this.$vs.loading();
            this.$crm.get(`/project/find-by-id/${this.projectId}`).then((response) => {
                this.$vs.loading.close();
                if (response.data) {
                    this.fileDataTable = response.data.fileManagers
                    if (this.fileDataTable && this.fileDataTable.length > 0) {
                        this.fileDataTable.forEach(el => {
                            el.createdDateCvt = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY HH:mm') : '';
                            el.metaData = JSON.parse(el.metaData)
                        })
                    }
                }
            });
        },

        dragover(e) {
            e.preventDefault()
            this.isDragging = true
        },
        dragleave() {
            this.isDragging = false
        },
        drop(e) {
            e.preventDefault()
            this.$refs.file.files = e.dataTransfer.files
            this.uploadFile()
            this.isDragging = false
        },

        uploadFile() {
            let file = this.$refs.file.files
            this.files.push(...file);
            this.$refs.file.value = null
        },

        confirmDeleteRecord(file, index) {
            this.files.splice(index, 1)
        },
    },
}
</script>
<style lang="scss">
.title-item {
    .vs-con-table .vs-con-tbody {
        height: calc(var(--vh, 1vh) * 100 - 490px) !important;
    }
}

#popup-upload-file {
    .upload {
        .file-upload {
            width: 200px;
            height: 200px;
            border: dashed 2px rgba(var(--vs-primary), 1);
            border-radius: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;

            .button-upload button {
                border-radius: 1.5rem;
            }

            .file-label {
                color: #C0C0C0;
            }
        }
    }
}

@media (min-width: 1340px) {
    #popup-upload-file {
        .vs-popup {
            width: 50% !important;
        }

        .table-files {
            width: calc(100% - 210px);
            margin-left: 10px;
        }
    }
}

@media screen and (max-width: 1339px) {
    #popup-upload-file {

        .upload {
            width: 100%;
        }

        .table-files {
            width: 100%;
            margin-top: 10px;
        }
    }
}
</style>
